import { SalaryCalculator } from "../components/salary-calculator.component";
import Sidebar from "../components/Sidebar";
import { Header } from "../components/header";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export function InvoiceSalaryCalculatorPage() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    return (
        <div className="dashboard-page">

            <div className="dashboard-layout">
                <Sidebar
                activeItemId='calculator'
                footer={null}
                onClose={() => setIsSidebarOpen(false)}
                className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                <div className="dashboard-main-content">
                    <Header
                    setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className="py-3">
                        <h1 className=" text-start mb-0 py-4 px-3 Heading_h4">{t('SALARY_CALCULATOR')}</h1>
                    </div>
                    <div className='pb-4 px-3'>
                        <SalaryCalculator isDashboardPage={false} />
                    </div>
                </div>
            </div>
        </div>
    );
}
